<template>
    <div class="layout">
        <div class="layout-left">
            <div class="layout-left-header">
                <img :src="site_info.img" alt="" style="object-fit: contain;">
                <span>{{ site_info.company_name }}</span>
            </div>
            <div class="layout-left-menu">
                <div class="menu-item" @click="changeMenu(0)" :class="menu_active === 0 ? ' active-menu' : ' '">
                    <img v-if="menu_active === 0" src="https://washoukd.oss-cn-shanghai.aliyuncs.com/HlnBaCJV6i.png"
                        alt="">
                    <img v-else src="https://washoukd.oss-cn-shanghai.aliyuncs.com/2yJTWj6wlG.png" alt="">
                    <span class="menu-item-name" :class="menu_active === 0 ? ' menu-item-name-active' : ' '">数据看板</span>
                </div>
                <div class="menu-item" @click="changeMenu(1)" :class="menu_active === 1 ? ' active-menu' : ' '">
                    <img v-if="menu_active === 1" src="https://washoukd.oss-cn-shanghai.aliyuncs.com/y0ZyC1qSGN.png"
                        alt="">
                    <img v-else src="https://washoukd.oss-cn-shanghai.aliyuncs.com/KQLNPdKPlk.png" alt="">
                    <span class="menu-item-name" :class="menu_active === 1 ? ' menu-item-name-active' : ' '">我的形象</span>
                </div>
                <div class="tip">
                    声音
                </div>
                <div class="menu-item" @click="changeMenu(2)" :class="menu_active === 2 ? ' active-menu' : ' '">
                    <img v-if="menu_active === 2" src="https://washoukd.oss-cn-shanghai.aliyuncs.com/YpFdUCExTW.png"
                        alt="">
                    <img v-else src="https://washoukd.oss-cn-shanghai.aliyuncs.com/U5YQ24ycXR.png" alt="">
                    <span class="menu-item-name" :class="menu_active === 2 ? ' menu-item-name-active' : ' '">声音克隆</span>
                </div>
                <div class="tip">
                    创作
                </div>
                <div class="menu-item" @click="changeMenu(3)" :class="menu_active === 3 ? ' active-menu' : ' '">
                    <img v-if="menu_active === 3" src="https://washoukd.oss-cn-shanghai.aliyuncs.com/7N9cQ9T3hS.png"
                        alt="">
                    <img v-else src="https://washoukd.oss-cn-shanghai.aliyuncs.com/4He6IcCb4b.png" alt="">
                    <span class="menu-item-name" :class="menu_active === 3 ? ' menu-item-name-active' : ' '">作品管理</span>
                </div>
                <div class="menu-item" @click="changeMenu(4)" :class="menu_active === 4 ? ' active-menu' : ' '">
                    <img v-if="menu_active === 4" src="https://washoukd.oss-cn-shanghai.aliyuncs.com/0g2gAemML2.png"
                        alt="">
                    <img v-else src="https://washoukd.oss-cn-shanghai.aliyuncs.com/WCz8fUV3YU.png" alt="">
                    <span class="menu-item-name" :class="menu_active === 4 ? ' menu-item-name-active' : ' '">个人中心</span>
                </div>
            </div>
        </div>
        <div class="layout-right">
            <div class="layout-right-header">
                <div class="creation" @click="toPage">
                    立即创作
                    <span class="iconfont icon-tianjiashipin"></span>
                </div>
                <div class="points">
                    <span class="iconfont icon-dianli"></span>
                    剩余{{ login_info.point }}点
                </div>
                <div class="title" @click="dh_dialogVisible = true">
                    <img src="../../assets/style/image/hg.png"></img>
                    卡密兑换
                </div>
                <div class="user-info" @click="loginOpen">
                    <img :src="login_info.avatar" alt="">
                    <el-dropdown>
                        <span>{{ login_info.name }}</span>
                        <el-dropdown-menu slot="dropdown" v-if="login_info.name !== '请登录'">
                            <el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </div>
            </div>
            <router-view></router-view>
        </div>

        <el-dialog :visible.sync="centerDialogVisible" width="40%" top="12%" center custom-class="login-dialog">
            <div class="dialog-main">
                <div class="dialog-left">
                    <img style="vertical-align: bottom;"
                        src="https://d.hxjpayment.cn/app/ycDigitalHuman/pc/static/image/signin.png" alt="">
                </div>
                <div class="dialog-right">
                    <div class="text-30" style="color:#e5eaf3;">欢迎登录</div>
                    <div class="text-12 margin-top-5" style="color:#909399">登录后即可使用更多功能</div>

                    <div class="login-main">
                        <div class="login-type">
                            <div v-for="item in login_type" @click="active_id = item.id"
                                :class="active_id === item.id ? 'active' : ''">
                                {{ item.name }}
                            </div>
                        </div>
                        <div>
                            <div class="margin-top-20" v-if="active_id === 0">
                                <el-input placeholder="请输入账号" prefix-icon="el-icon-user"
                                    v-model="login_data.account"></el-input>
                            </div>
                            <div class="margin-top-20" v-if="active_id === 1">
                                <el-input placeholder="请输入账号" prefix-icon="el-icon-mobile" v-model="login_data.phone">
                                </el-input>
                            </div>

                            <div class="margin-top-20 flex">
                                <el-input placeholder="请输入图形验证码" prefix-icon="el-icon-picture-outline"
                                    v-model="login_data.captcha"></el-input>
                                <img class="margin-left-sm" @click="updataCaptcha" style="width:200px;height: 40px;"
                                    :src="login_data.img" alt="">
                            </div>

                            <div class="margin-top-20" v-if="active_id === 0">
                                <el-input placeholder="请输入验证码" prefix-icon="el-icon-mobile"
                                    v-model="login_data.phoneCaptcha" oninput="value=value.replace(/[^0-9]/g,'')">
                                    <template #append>
                                        <el-button v-if="countdown_flag" @click="goPhoneCaptcha"
                                            :disabled="login_data.captcha === ''"
                                            style="background: #0d1116;border: none;line-height: 16px !important;margin: -10px -23px;">获取验证码</el-button>
                                        <span v-else>{{ countdown }}</span>
                                    </template>
                                </el-input>
                            </div>


                            <div class="margin-top-20" v-if="active_id === 1">
                                <el-input placeholder="请输入密码" show-password prefix-icon="el-icon-unlock"
                                    v-model="login_data.password">
                                </el-input>
                            </div>
                        </div>

                        <div class="margin-top-10 text-12">登录即代表您已同意 <span @click="dialogVisible = true"
                                style="color: #19b158;">《用户协议》</span>
                        </div>

                        <div v-if="active_id === 0"
                            class="w-full margin-top-20 text-black padding-xs box-sizing text-center round-50"
                            @click="loginInTel"
                            style="background: linear-gradient(135deg, #31c184 9.27%, #009688 46.96%, #278ee4 88.5%);">
                            登录</div>

                        <div v-if="active_id === 1"
                            class="w-full margin-top-20 text-black padding-xs box-sizing text-center round-50"
                            @click="loginInPwd"
                            style="background: linear-gradient(135deg, #31c184 9.27%, #009688 46.96%, #278ee4 88.5%);">
                            登录</div>

                    </div>
                </div>

                <i @click="centerDialogVisible = false" class="el-icon-close"></i>
            </div>
        </el-dialog>


        <el-dialog :visible.sync="dialogVisible" modal width="70%" custom-class="syxy-dialog">
            <div class="text-left text-20">
                使用协议
            </div>
            <div v-html="content">

            </div>
        </el-dialog>


        <el-dialog :visible.sync="dh_dialogVisible" modal width="70%" custom-class="dh-dialog" :show-close="false">
            <!-- <div style="background: url('https://washoukd.oss-cn-shanghai.aliyuncs.com/8pWMpVgSwz.png') no-repeat;width: 100%;height: 568px;">
            </div> -->
            <div style="width: 100%;height: 625px;position: relative;" class="dh_box">
                <div
                    style="position: absolute; bottom: 40%;width: 100%; left: 50%;transform: translate(-50%); display: flex; align-items: center;justify-content: center;">
                    <el-input style="margin-right: 40px;width: 50%;" placeholder="请输入卡密" v-model="km_input" />
                    <el-button
                        style="background:#41cf82;border: none;border-radius: 30px;padding: 12px 40px;font-weight: 900;"
                        type="primary" @click="kmdh">卡密兑换</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: 'layouts',
    data() {
        return {
            km_input: '',
            dh_dialogVisible: false,
            login_info: {
                avatar: 'https://washoukd.oss-cn-shanghai.aliyuncs.com/FmzgfVNQIB.png',
                name: '请登录',
                point: 0
            },
            login_data: {
                id: '',
                key_type: '',
                account: '',
                captcha: '',
                phoneCaptcha: '',
                phone: '',
                password: '',
                img: 'data:image/png;base64,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',
                uuid: '',
            },
            active_id: 0,
            login_type: [
                { name: '验证码登录', id: 0 },
                { name: '密码登录', id: 1 }
            ],
            circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            site_info: {
                company_name: '娲手AI数字人',
                img: 'https://washoukd.oss-cn-shanghai.aliyuncs.com/667522498c7ba.png',
            },
            left_menu: [
                { icon: 'icon-shuju2', name: '数据看板' },
                { icon: 'icon-mynormal', name: '我的形象' },
                { icon: 'icon-shengyinkelong', name: '克隆声音' },
                { icon: 'icon-shipin1', name: '作品管理' },
                { icon: 'icon-wode1', name: '个人中心' },
            ],
            menu_active: 0,
            centerDialogVisible: true,
            dialogVisible: false,
            loginFlag: false,
            beatHeard: false,
            sendbeatHeartTimer: null,
            socketDestory: true,
            ws: null,
            countdown_flag: true,
            countdownTimer: null,
            countdown: 60,
            content: `<p style="text-align:left">本声明将帮助您更好的在【娲手AI数字人】平台（下称“本平台”）使用相关工具上传和管理您的作品。您若上传作品，即视为您已充分知悉并充分接受以下内容：</p><ul><li style="text-align: start;">您作为使用者在本平台上传、发布的作品，应具有独立、完整的知识产权，不得侵犯他人知识产权等任何权利。</li><li style="text-align: start;">您在使用本平台及上传、发布作品时，应当自觉遵守国家法律、法规，遵守公共秩序，尊重社会公德、社会主义制度、国家利益、公民合法权益、道德风尚和信息真实性等要求。如有违反，一经本平台发现将根据违规程度采取包括但不限于删除、下架、禁止发布内容、封禁账号等处理方式。如造成恶劣影响或涉嫌违法犯罪的，本平台将有权向有关管理机关或公安机关提交相关内容，并配合进行调查。您承诺所提供的素材内容为您本人所有或已获得合法授权，并遵守<span style="color: var(--lvv-color-main-default);">《“娲手”AI功能使用规范 》</span></li><li style="text-align: start;">若您上传的作品及作品中的素材（包括但不限于创意、文本、肖像、音频、图片、视频等）侵犯了任何第三方权利，本平台均有权在收到相关侵权投诉后对该被投诉的作品或用户账号依据相应规则，采取包括但不限于下架、警告、封禁账号等处理方式。</li><li style="text-align: left;">为实现“数字人”功能，娲手AI数字人需处理您输入的文本内容，若因您不当使用本功能导致任何第三方权益受损，您将依法承担相应责任，请您谨慎使用。为避免侵权，如您选择克隆形象，娲手AI数字人会校验定制的人声、人脸是否有合法授权；如您选择上传照片形象，娲手AI数字人会进行人脸校验。</li><li style="text-align: left;">为提供相关功能保证优质处理效果，娲手AI数字人会将您主动选择或提供的素材内容回传至服务端，并会全程采用安全加密的方式。</li></ul><p style="text-align: left;"><br></p><p><br></p>`
        }
    },
    watch: {
        $route(newval, oldval) {
            console.log(newval, oldval, 'newval,oldvalnewval,oldvalnewval,oldval');
            switch (newval.path) {
                case '/home':
                    this.menu_active = 0
                    break
                case '/digital':
                    this.menu_active = 1
                    break
                case '/audio':
                    this.menu_active = 2
                    break
                case '/works':
                    this.menu_active = 3
                    break
                case '/user':
                    this.menu_active = 4
                    break
            }
        }
    },

    created() {
        console.log(this.$route, 'this.$route.paththis.$route.path');
        //刷新重置菜单栏点亮
        switch (this.$route.path) {
            case '/home':
                this.menu_active = 0
                break
            case '/digital':
                this.menu_active = 1
                break
            case '/audio':
                this.menu_active = 2
                break
            case '/works':
                this.menu_active = 3
                break
            case '/user':
                this.menu_active = 4
                break
        }

        this.login_data.id = this.$route.query.id
        this.login_data.key_type = 'id'
        if (this.$route.query.id !== undefined) {
            localStorage.setItem('USERID', this.$route.query.id)
            this.login_data.key_type = 'id'
        }

        this.getSiteConfig(this.login_data.id, this.login_data.key_type)


        let logininfo = JSON.parse(localStorage.getItem('LOGININFO'))

        if (logininfo !== null) {
            this.loginFlag = true
            this.centerDialogVisible = false
            this.getUserInfo(this.login_info.id)

        } else {
            this.loginFlag = false
            this.centerDialogVisible = true
        }

        this.$Bus.$on('soketMessage', this.showMessage)

        this.$Bus.$on('AiSoketMessage', this.AiShowMessage)

    },
    mounted() {
        let login_flag = JSON.parse(localStorage.getItem('LOGININFO'))
        if (login_flag !== undefined) {
            this.wsService()
        }
    },
    beforeDestroy() {
        clearInterval(this.sendbeatHeartTimer)
        this.socketDestory = false;
        if (this.ws) {
            this.ws.close();
        }
    },

    beforeUnmount() {
        clearInterval(this.sendbeatHeartTimer)
        this.socketDestory = false;
        if (this.ws) {
            this.ws.close();
        }
    },
    unmounted() {
        clearInterval(this.sendbeatHeartTimer)
        this.socketDestory = false;
        if (this.ws) {
            this.ws.close();
        }
    },
    methods: {
        async kmdh() {
            if (this.km_input === '') {
                this.$message.error('请输入卡密')
                return false
            }

            let res = await this.$API.user.exchangeCdk.post({
                code: this.km_input
            })

            if (res.code === 200) {
                this.$message.success(res.message)
                this.dh_dialogVisible = false
                this.km_input = ''
            } else {
                this.$message.error(res.message)
            }

            console.log(res, '11111111111111111');
            //CDk 兑换
            // exchangeCdk(data){
            // 	return http.post('/user/exchangeCdk',data)
            // },

        },
        AiShowMessage(message) {
            this.ws.send(
                JSON.stringify({
                    event: "tools",
                    data: {
                        bot_id: '7483794117651447834',
                        content: message
                    }
                })
            )
        },
        showMessage(message) {
            this.ws.send(
                JSON.stringify({
                    event: "tools",
                    data: {
                        bot_id: '7483730338222096420',
                    }
                })
            )
        },

        wsService() {
            let token = JSON.parse(localStorage.getItem('LOGININFO')).userInfo.uuid
            // this.ws = new WebSocket(`wss://humanapi.hxjpayment.cn/ws/human-chat?HTTP_MERCHANT_TOKEN=daba264d-185a-174c-7d19-aadaf42fb8d4`);
            this.ws = new WebSocket(`wss://humanapi.hxjpayment.cn/ws/human-chat?HTTP_MERCHANT_TOKEN=${token}`);
            this.ws.onopen = () => {
                this.beatHeard = false;
                this.sendbeatHeartTimer = setInterval(() => {
                    this.ws.send(JSON.stringify({ type: "web_beatHeart" }));
                }, 10000);
            };

            this.ws.onmessage = (evt) => {
                //绑定收到消息事件
                const data = evt.data;
                const newData = JSON.parse(data);
                console.log(newData, 'newDatanewDatanewData');
                switch (newData.event) {
                    case "chat_done":
                        this.$Bus.$emit('randomMessage', newData.content.content)
                        break;
                }
            };

            this.ws.onclose = () => {
                this.beatHeard = true;
                //绑定关闭或断开连接事件
                // console.log("连接已关闭");
                this.ws.close();

                if (this.beatHeard) {
                    if (this.socketDestory) {
                        setTimeout(() => {
                            this.ws.close();
                            this.wsService();
                        }, 3000);
                    }

                }
            };
        },


        toPage() {
            this.$router.push({
                path: '/digital',
                query: {
                    id: localStorage.getItem('USERID')
                }
            })
        },
        loginOut() {
            console.log(11111111111111);
            localStorage.removeItem('LOGININFO')
            this.login_info.name = '请登录'
            this.login_info.avatar = 'https://washoukd.oss-cn-shanghai.aliyuncs.com/FmzgfVNQIB.png'
            this.$router.push({
                path: '/home',
                query: {
                    id: localStorage.getItem('USERID')
                }
            })
        },
        async getSiteConfig(key, key_type) {
            let res = await this.$API.login.getSiteConfig.get({
                key,
                key_type
            })
            if (res.code === 200) {
                this.site_info.company_name = res.data.title
                this.site_info.img = res.data.ico
                localStorage.setItem('UUID', JSON.stringify(res.data.uuid))

                this.getCaptcha()
            } else {
                this.$message.error(res.message)
            }
            // console.log(res,'rsrsrsrs');
        },

        async getUserInfo(id) {
            let res = await this.$API.user.getInfo.get({
                id,
            })
            if (res.code !== null) {
                this.loginFlag = true
                this.login_info.avatar = res.data.avatar
                this.login_info.name = res.data.nickname
                this.login_info.point = res.data.point
            } else {
                this.loginFlag = false
                this.centerDialogVisible = true
            }
            // console.log(res,'rsrsrsrs');
        },
        loginOpen() {
            if (this.login_info.name == '请登录') {
                this.getSiteConfig(this.login_data.id, this.login_data.key_type)
                this.centerDialogVisible = true

            } else {
                this.$router.push({
                    path: '/user',
                    query: {
                        id: localStorage.getItem('USERID')
                    }
                })
            }
        },
        async loginInTel() {
            if (this.login_data.phoneCaptcha === '') {
                this.$message.error('请输入手机验证码')
                return false
            }

            if (this.login_data.account === '') {
                this.$message.error('请输入手机号')
                return false
            }

            if (this.login_data.captcha === '') {
                this.$message.error('请输入图形验证码')
                return false
            }

            let res = await this.$API.login.webLogin.get({
                mobile: this.login_data.account,
                code: this.login_data.phoneCaptcha,
            })

            if (res.code === 200) {
                this.centerDialogVisible = false
                this.login_info.avatar = res.data.userInfo.avatar
                this.login_info.name = res.data.userInfo.nickname
                this.login_info.point = res.data.userInfo.point
                // this.loginFlag = true
                localStorage.setItem('LOGININFO', JSON.stringify(res.data))
                this.wsService()
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }

        },


        async loginInPwd() {

            if (this.login_data.phone === '') {
                this.$message.error('请输入账号')
                return false
            }

            if (this.login_data.password === '') {
                this.$message.error('请输入密码')
                return false
            }

            if (this.login_data.captcha === '') {
                this.$message.error('请输入图形验证码')
                return false
            }

            let res = await this.$API.login.webAccountLogin.post({
                account: this.login_data.phone,
                password: this.login_data.password,
                captcha_uuid: this.login_data.uuid,
                input_captcha: this.login_data.captcha,
            })

            if (res.code === 200) {
                this.centerDialogVisible = false
                this.login_info.avatar = res.data.userInfo.avatar
                this.login_info.name = res.data.userInfo.nickname
                this.login_info.point = res.data.userInfo.point
                // this.loginFlag = true
                localStorage.setItem('LOGININFO', JSON.stringify(res.data))
                this.wsService()
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }

        },



        async goPhoneCaptcha() {
            if (this.login_data.account === '') {
                this.$message('请输入手机号')
                return false
            }

            let res = await this.$API.login.sendSms.get({
                mobile: this.login_data.account,
                captcha_uuid: this.login_data.uuid,
                input_captcha: this.login_data.captcha,
                event: 'login'
            })
            if (res.code === 200) {
                this.countdown_flag = false
                this.countdownTimer = setInterval(() => {
                    this.countdown--
                    if (this.countdown === 0) {
                        this.countdown_flag = true
                        this.countdown = 60
                        clearInterval(this.countdownTimer)
                    }
                }, 1000);
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        updataCaptcha() {
            this.getCaptcha()
        },
        async getCaptcha() {
            let res = await this.$API.login.getCaptcha.get()
            if (res.code === 200) {
                this.login_data.img = res.data.image
                this.login_data.uuid = res.data.uuid
            } else {
                this.$message.error(res.message)
            }
        },
        changeMenu(index) {
            this.menu_active = index
            switch (index) {
                case 0:
                    if (this.$route.fullPath != '/home') {
                        this.$router.push({
                            path: '/home',
                            query: {
                                id: localStorage.getItem('USERID')
                            }
                        })
                    }
                    break
                case 1:
                    if (this.$route.fullPath != '/digital') {
                        this.$router.push({
                            path: '/digital',
                            query: {
                                id: localStorage.getItem('USERID')
                            }
                        })
                    }
                    break
                case 2:
                    if (this.$route.fullPath != '/audio') {
                        this.$router.push({
                            path: '/audio',
                            query: {
                                id: localStorage.getItem('USERID')
                            }
                        })
                    }
                    break
                case 3:
                    if (this.$route.fullPath != '/works') {
                        this.$router.push({
                            path: '/works',
                            query: {
                                id: localStorage.getItem('USERID')
                            }
                        })
                    }
                    break
                case 4:
                    if (this.$route.fullPath != '/user') {
                        this.$router.push({
                            path: '/user',
                            query: {
                                id: localStorage.getItem('USERID')
                            }
                        })
                    }
                    break
            }
        }
    }
}
</script>

<style lang="scss" scoped>
:deep(.syxy-dialog) {
    background: #0d1116 !important;

    .el-dialog__body {
        padding: 20px !important;
        color: #fff !important;
    }

    .el-input__inner {
        background: #0d1116 !important;
        border: none !important;
    }
}

:deep(.dh-dialog) {
    background: url('https://washoukd.oss-cn-shanghai.aliyuncs.com/8pWMpVgSwz.png') no-repeat;
    background-size: 100% 100%;
    background-position: 55px;
    height: 625px;
    box-shadow: none !important;

    .dh_box {
        .el-input__inner {
            background: #0a0a0a;
            border: 1.5px solid #41d082 !important;
            border-radius: 30px;
            color: #fff;
        }
    }
}

.dialog-main {
    display: flex;
    background: #192227;
    position: relative;

    .dialog-left {
        flex: 2;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .dialog-right {
        padding: 20px;
        flex: 3;

        .login-main {
            margin-top: 40px;

            .login-type {
                display: flex;

                div {
                    margin-right: 50px;
                    font-size: 16px;
                    font-weight: 500;
                    color: #fff;
                }

                .active {
                    background: linear-gradient(135deg, #31c184 9.27%, #009688 46.96%, #278ee4 88.5%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    position: relative;
                }

                .active::after {
                    position: absolute;
                    content: '';
                    height: 3px;
                    bottom: -10px;
                    left: 0;
                    width: 100%;
                    background: linear-gradient(135deg, #31c184 9.27%, #009688 46.96%, #278ee4 88.5%);
                }
            }
        }
    }

    .el-icon-close {
        right: 30px;
        top: 30px;
        position: absolute;
        color: #fff;
        font-size: 20px;
    }
}

:deep(.login-dialog) {
    .el-dialog__header {
        display: none !important;
    }

    .el-dialog__body {
        padding: 0 !important;
    }

    .el-input__inner {
        background: #0d1116;
        border: none !important;
        color: #fff !important;
    }
}


.layout {
    display: flex;
    background: #0d1116;
    width: 100%;
    height: 100%;
    color: #fff;

    .layout-left {
        width: 17%;
        text-align: center;
        background: #1a1d22;
        padding: 24px 0;
        box-sizing: border-box;
        border-radius: 0 40px 40px 0;

        .layout-left-header {
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'wdch';
            font-size: 24px;

            img {
                width: 66px;
                height: 22px;
                margin-right: 10px;
            }
        }

        .layout-left-menu {
            width: 100%;
            padding-top: 30px;

            .menu-item {
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: 'PingFangsC-Regular';
                height: 90px;
                width: 100%;
                margin: -5px 0;
                cursor: default;

                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                }

                .menu-item-name {
                    font-size: 18px;
                }

                .menu-item-name-active {
                    font-weight: 900;
                    background: linear-gradient(90deg, #36faa2, #4681ff);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .tip {
                width: 100%;
                text-align: left;
                margin-left: 22%;
                height: 30px;
                line-height: 30px;
                color: #a8a8a8;
                font-family: 'PingFangsC-Regular';
                font-size: 18px;
            }

            .active-menu {
                background: url('https://washoukd.oss-cn-shanghai.aliyuncs.com/FFE2ZgsPi5.png') no-repeat;
                background-size: 80% 125%;
                background-position: 103% 50%;
            }
        }
    }

    .layout-right {
        width: 100%;
        height: 100%;

        .layout-right-header {
            display: flex;
            align-items: center;
            justify-content: end;
            padding: 24px;

            .creation {
                width: 132px;
                height: 42px;
                background: linear-gradient(90deg, #4bdb84, #3593ff);
                border-radius: 20px;
                line-height: 42px;
                color: #000;
                font-size: 16px;
                font-family: 'PingFangsC-Regular';
                margin-right: 20px;
                font-weight: 900;
                cursor: default;
            }

            .points {
                // width: 130px;
                height: 42px;
                line-height: 42px;
                background: #26292e;
                border-radius: 20px;
                font-family: 'PingFangsC-Regular';
                font-size: 16px;
                margin-right: 20px;
                font-weight: 900;
                padding: 0 15px 0 10px;

                .icon-dianli {
                    border: 2px solid #3d3f43;
                    border-radius: 50%;
                    padding: 3px;
                    color: #3693FF;
                }
            }

            .title {
                background: #FFF1DE;
                font-family: 'PingFangsC-Regular';
                font-size: 16px;
                width: 146px;
                height: 42px;
                line-height: 42px;
                border-radius: 20px;
                color: #55402B;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 900;
                cursor: default;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 5px;
                }
            }

            .user-info {
                width: 180px;
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: 'PingFangsC-Regular';
                font-size: 14px;
                font-weight: 900;

                img {
                    width: 42px;
                    height: 42px;
                    margin-right: 10px;
                }

                span {
                    cursor: default;
                }
            }
        }
    }

}
</style>